<!--
 * @Author: Gexiaolei
 * @Date: 2022-12-01 10:17:49
 * @LastEditors: Gexiaolei gxiaolei@163.com
 * @Description: 接入单据转派能力
-->
/**
*  maintained by gexiaolei
接入单据转派能力
*/
<template>
  <div class="record-wrapper">
    <span v-if="tableList.length && params.purchaseApplyCode" class="font-color-link" @click="reassignVisible = true">{{pageText.record}}</span>
    <SyPopup
      :title="pageText.record"
      class="pr-rate-dialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      size="medium"
      v-model="reassignVisible"
      :before-close="close"
    >
      <SyTable
        ref="assignWrapper"
        :data-source="tableList">
          <SyTableColumn :title="pageText.operatCons" width="200" prop="operateContent">
            <template slot-scope="scope"><p v-html="getOperateContent(scope.row.operateContent)"></p></template>
          </SyTableColumn>
          <SyTableColumn :title="pageText.operatType" width="120" prop="operateType">
            <template slot-scope="scope">{{scope.row.operateType || '-'}}</template>
          </SyTableColumn>
          <SyTableColumn :title="pageText.operator" width="100" prop="operationPerson">
            <template slot-scope="scope">{{scope.row.operatorName}}（{{scope.row.operatorWorkNumber}}）</template>
          </SyTableColumn>
          <SyTableColumn :title="pageText.operatTime" width="120" prop="operationTime">
            <template slot-scope="scope">{{scope.row.operateTime || '-'}}</template>
          </SyTableColumn>
      </SyTable>
    </SyPopup>
  </div>
</template>

<script>
import SyPopup from '../../basis/fe-popup/index.vue'
import { componentMessage } from '../utils'
import SyTable, {SyTableColumn} from '../../basis/fe-table/index'
import i18n from './i18n.js'
import Api from './api'
import GetData from '../../../utils/response'
import createDOMPurify from 'dompurify'
const DOMPurify = createDOMPurify(window)
const pageText = window.fe.getPageText(i18n)
export default {
  components: {
    SyPopup,
    SyTable,
    SyTableColumn
    // FTable
  },
  props: {
    // reassignVisible: {
    //   type: Boolean,
    //   default: false
    // },
    // 请求参数（申请单号）
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      pageText,
      reassignVisible: false,
      // tableList: [{operateContent: '操作内容', operatorWorkNumber: '操作人工号', operatorName: '操作人名称', operateType: '操作类型', operateTime: '操作时间'}]
      tableList: []
    }
  },
  created () {
    // 适用于商城端和采购商端
    let flag = componentMessage(['mall', 'purchaser'], 'reassignment-dialog 转派记录弹窗【适用于PR】')
    if (flag) {
      return
    }
    this.fetchData()
  },
  methods: {
    async fetchData () {
      if (!this.params.purchaseApplyCode) return
      const api = Api.transferRecord
      const res = await GetData(this.$http(api.type, api.url, this.params))
      if (res.isOk) {
        this.tableList = res.content || []
      }
    },
    getOperateContent (content) {
      return DOMPurify.sanitize((content || '-').replace(/\n/g, '<br />'))
    },
    // 关闭弹窗
    close () {
      // this.$emit('update:reassignVisible', false)
      this.reassignVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .record-wrapper {
    display: inline-block;
  }
</style>
